import { render, staticRenderFns } from "./class.vue?vue&type=template&id=a25edbe0&scoped=true&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"
import style0 from "./class.vue?vue&type=style&index=0&id=a25edbe0&lang=scss&scoped=true&"
import style1 from "./class.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25edbe0",
  null
  
)

export default component.exports